export default "__VITE_ASSET__D4PxVIt2__"